<template>
  <div class="newrealauth">
     <z-fix-top
      keep-position
      class="fixtop"
    >
      <z-nav-bar
          class="navbar"
          left-arrow
          title="实名认证"
          :right-text="result ? '' : '更改认证方式'"
          @click-left="closePage"
          @click-right="changeWay"
      >
      </z-nav-bar>
    </z-fix-top>
    <z-notice-bar
        v-show="!result"
        left-icon="volume-o"
        :scrollable="false"
        :text="yellowStripe"
      />
    <!-- 提交状态 -->
    <template v-if="!result">
      <div class="commit-info">
        <div class="guide-title">{{ title }}</div>
        <div class="guide-info">
          {{ content }}
        </div>
        <div class="cardType">
          证件类型：{{cardType}}
        </div>
        <section v-if="['0','1'].includes(authType)" class="upload-area">
          <media-upload-item ocr :sdkOptions="{ type: '1' }" :authType="authType" :cover="frontCover" :tip="frontTip" type="front" @uploaded="frontPicUploaded">
          </media-upload-item>
          <media-upload-item :sdkOptions="{ type: '1' }" :authType="authType" :cover="backCover" :tip="backTip" type="back" @uploaded="backPicUploaded">
          </media-upload-item>
        </section>
        <section v-else class="upload-area-single">
          <media-upload-item ocr :authType="authType" :cover="frontCover" :tip="frontTip" type="front" @uploaded="frontPicUploaded">
          </media-upload-item>
        </section>

        <z-field v-model="name" placeholder="请输入真实姓名" />

        <z-field
          v-if="['0','1'].includes(authType)"
          use-number-keyboard
          v-model="cardId"
          placeholder="请输入证件号码"
          maxlength="18"
          @focus="showNumberKeyboard = true"
          @blur="showNumberKeyboard = false"
        />
         <z-field v-else v-model="cardId" maxlength="18" placeholder="请输入证件号码" />
        <z-divider />

        <z-checkbox-group v-model="radio">
          <z-checkbox v-if="isZZ" name="zz">
            我已阅读并同意
            <span :style="{ color: '#42A0FF' }" @click.stop="zzagreement">《实人认证服务协议》</span>
          </z-checkbox>

          <z-checkbox v-if="isSJJ" name="sjj">
            我已阅读并同意
            <span :style="{ color: '#42A0FF' }" @click.stop="sjjagreement">《实人认证服务协议》</span>
          </z-checkbox>

          <z-checkbox name="privacy">
            我已阅读并同意
            <span :style="{ color: '#42A0FF' }" @click.stop="checkInfo">《个人信息处理授权书》</span>
          </z-checkbox>

          <z-checkbox v-if="isZLJ" name="zlj">
            我已阅读并同意
            <span :style="{ color: '#42A0FF' }" @click.stop="zljagreement">《找靓机身份识别服务协议》</span>
          </z-checkbox>
        </z-checkbox-group>
        <z-button-group>
          <z-button type="primary" :loading="submiting" :disabled="!canSubmit" @click="submit">提交</z-button>
        </z-button-group>
      </div>
    </template>

    <z-actionsheet
      title="更改认证方式"
      v-model="showModal"
      :actions="actions"
      cancel-text="取消"
      @select="onSelect"
    />

    <z-number-keyboard
      close-on-click-overlay
      :show="showNumberKeyboard"
      extra-key="X"
      @input="onInput"
      @delete="onDelete"
    >
      <!-- <div class="slot">{{ cardId }}</div> -->
    </z-number-keyboard>

    <!-- 结果状态 -->
    <template v-if="result">
      <div class="real-auth-result">
        <img :src="$setPicSize(successImg)" alt="">
        <header>{{ desc }}</header>
        <z-button type="primary" @click="closePage">返回</z-button>
      </div>
    </template>
  </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import { NavBar, Button, ButtonGroup, FixTop, NoticeBar, Field, Checkbox, CheckboxGroup, Divider, Actionsheet, NumberKeyboard, Dialog } from '@zz-common/zz-ui';
import { lego } from '@zz-common/lego'
import { apiNewRealAuthSubmitAuto, apiNewRealAuthSubmitHandle, getpagetext } from '@api/resourceApi'
import MediaUploadItem from './MediaUploadItem/MediaUploadItem'
import { getMaskData, setPicSize } from '@zz-common/zz-utils'
import { queryParams, getCookie } from '../../lib/utils'

const query = queryParams()

export default {
  name: 'CommitInfo',
  data() {
    // 获取Cookie中的t值判断是否为奢竞界APP
    const tValue = getCookie('t')
    const isSJJ = tValue === '243' || tValue === '244'
    return {
      radio: [],
      name: '',
      cardId: '',
      picKeyFro: '',
      picKeyBack: '',
      //顶部文字
      yellowStripe: '认证成功后，实名不可更改。',
      content: '',
      title: '',
      successImg: require('./images/auth_success.png'),
      sourcecode: query.sourcecode || this.$route.query.sourcecode || '',
      originsource: query.originsource || this.$route.query.originsource || '',
      authType: query.authType || this.$route.query.authType, //认证方式
      result: false,
      submiting: false,
      showModal: false,
      showNumberKeyboard: false,
      actions: [
        { name: '中华人民共和国居民身份证', value: '0' },
        { name: '中华人民共和国港澳台居民居住证', value: '1' },
        { name: '港澳居民来往内地通行证', value: '2' },
        { name: '台湾居民来往大陆通行证', value: '3' }
      ],
      isSJJ, // 奢竞界APP
      isZZ: native.in('zz'),
      isZLJ: native.in('zlj'),
      frontCover1: require('@assets/img/id_card_front_sample_new.png'),
      frontCover2: require('@assets/img/id_card_entrance_new.png'),
      backCover1: require('@assets/img/id_card_back_sample_new.png'),
      desc: '恭喜您认证成功',
      backTip: '',
      frontTip: ''
    }
  },
  computed: {
    /**
     * 判断是否可以提交
     * 需要满足：基本信息填写完整 + 所有显示的协议都已勾选
     */
    canSubmit() {
      // 个人信息处理授权书是必选的
      const hasPrivacy = this.radio.includes('privacy')
      // 转转实人认证服务协议（如果显示）
      const hasZZ = !this.isZZ || this.radio.includes('zz')
      // 找靓机身份识别服务协议（如果显示）
      const hasZLJ = !this.isZLJ || this.radio.includes('zlj')
      // 奢竞界实人认证服务协议（如果显示）
      const hasSJJ = !this.isSJJ || this.radio.includes('sjj')
      // 所有协议都已勾选
      const hasAllAgreements = hasPrivacy && hasZZ && hasZLJ && hasSJJ

      if (['0', '1'].includes(this.authType)) {
        return this.name && this.cardId && hasAllAgreements && this.picKeyFro && this.picKeyBack
      } else {
        return this.name && this.cardId && hasAllAgreements && this.picKeyFro
      }
    },
    cardType() {
      return this.actions.find(t => t.value == this.authType)?.name || '-'
    },
    frontCover() {
      if (['0', '1'].includes(this.authType)) {
        return this.frontCover1
      } else {
        return this.frontCover2
      }
    },
    backCover() {
      return this.backCover1
    }
  },
  components: {
    'z-nav-bar': NavBar,
    'z-fix-top': FixTop,
    'z-button': Button,
    'z-divider': Divider,
    'z-checkbox-group': CheckboxGroup,
    'z-checkbox': Checkbox,
    'z-button-group': ButtonGroup,
    'z-notice-bar': NoticeBar,
    'z-field': Field,
    'z-actionsheet': Actionsheet,
    'z-number-keyboard': NumberKeyboard,
    MediaUploadItem
  },
  mounted() {
    // 如果URL没有传sourcecode，根据不同APP设置默认值
    if (!this.sourcecode) {
      this.sourcecode = this.isSJJ ? 'c2p_selfmain_page' : 'card_selfmain_page'
    }
    native.wrap('setHeaderVisible')({
      visible: '0'
    })
    // 身份号认证获取页面文案信息
    getpagetext({
      sourcecode: this.sourcecode
    })
      .then((res) => {
        this.content = res.content
        this.title = res.title
        this.yellowStripe = res.yellowStripe || this.yellowStripe
      })
      .catch((err) => {
        this.$toast(err)
      })

    lego.send({
      pagetype: 'auth_withcard',
      actiontype: 'show',
      backup: {
        sourcecode: this.sourcecode,
        version: getCookie('v'),
        app: native.in('zz') ? 'zz' : 'zlj',
        authType: this.authType,
        originsource: this.originsource
      }
    })
  },
  methods: {
    $setPicSize(url) {
      return setPicSize(url)
    },
    zzagreement() {
      native.skipToUrl({
        targetUrl: 'https://m.zhuanzhuan.com/Mzhuanzhuan/zhuanzhuan/zzactivity/magic/67e371c0da1f4e0062fc0d97/index.html?magicplatform=zz&needNewWebview=1',
        needClose: '0'
      })
    },
    zljagreement() {
      native.skipToUrl({
        targetUrl: 'https://m.zhuanzhuan.com/Mzhuanzhuan/zhuanzhuan/zzactivity/magic/6401c5d7c955420077193c75/index.html?magicplatform=zlj&needNewWebview=1',
        needClose: '0'
      })
    },
    sjjagreement() {
      native.skipToUrl({
        targetUrl: 'https://m.zhuanzhuan.com/Mzhuanzhuan/zhuanzhuan/zzactivity/magic/691c3375ee471600647e64f8/index.html?magicplatform=zz&needNewWebview=1',
        needClose: '0'
      })
    },
    checkInfo() {
      native.skipToUrl({
        targetUrl: 'https://m.zhuanzhuan.com/Mzhuanzhuan/zhuanzhuan/zzactivity/magic/6401a9e6447e27006914ecb0/index.html?magicplatform=common&needNewWebview=1',
        needClose: '0'
      })
    },
    frontPicUploaded(rst, ocr = '') {
      lego.send({
        pagetype: 'auth_withcard',
        actiontype: 'front_pic',
        backup: {
          sourcecode: this.sourcecode,
          version: getCookie('v'),
          app: native.in('zz') ? 'zz' : 'zlj',
          authType: this.authType,
          originsource: this.originsource
        }
      })
      this.picKeyFro = rst
      if (ocr && !this.name && !this.cardId) {
        this.name = ocr.name
        this.cardId = ocr.cardId
      }
    },
    backPicUploaded(rst, _ocr = '') {
      lego.send({
        pagetype: 'auth_withcard',
        actiontype: 'back_pic',
        backup: {
          sourcecode: this.sourcecode,
          version: getCookie('v'),
          app: native.in('zz') ? 'zz' : 'zlj',
          authType: this.authType,
          originsource: this.originsource
        }
      })
      this.picKeyBack = rst
    },
    changeWay() {
      if (this.result) return
      this.showModal = true
    },
    onSelect(val) {
      this.showModal = !this.showModal
      this.authType = val.value
    },
    // isUserNameValid() {
    //   var regName = /^[\u4e00-\u9fa5]+(·[\u4e00-\u9fa5]+)*$/
    //   return regName.test(this.name)
    // },
    // isIDCardValid() {
    //   var regIdNo = /(^\d{18}$)|(^\d{17}(\d|X|x)$)/
    //   return regIdNo.test(this.cardId)
    // },
    submit() {
      console.info(`姓名：${this.name}`)
      console.info(`身份证：${this.cardId}`)
      console.info(`from：${this.sourcecode}`)
      this.submiting = true
      lego.send({
        pagetype: 'auth_withcard',
        actiontype: 'submit',
        backup: {
          sourcecode: this.sourcecode,
          version: getCookie('v'),
          app: native.in('zz') ? 'zz' : 'zlj',
          authType: this.authType,
          originsource: this.originsource
        }
      })
      const params = {
        name: this.name,
        cardId: this.cardId,
        sourcecode: this.sourcecode,
        originsource: this.originsource,
        picKeyFro: this.picKeyFro,
        picKeyBack: this.picKeyBack,
        type: this.authType
      }
      apiNewRealAuthSubmitAuto(params)
        .then((res) => {
          const maskData = getMaskData({
            A01_11: this.name,
            C01_07: this.cardId,
            C02_01: ''
          })
          lego.send({
            pagetype: 'privacy',
            actiontype: 'information',
            backup: {
              value: JSON.stringify(maskData || {})
            }
          })
          if (res != true) {
            Dialog({
              title: '信息审核未通过',
              message: '经系统检测，提交证件信息与填写信息信息不一致，请确认信息是否正确，如信息无误，可提交人工审核，审核通过后不可更改。',
              confirmButtonText: '确认无误，提交审核',
              business: true,
              showTopClose: true,
              closeOnClickOverlay: false
            }).then(() => {
              apiNewRealAuthSubmitHandle(params).then(_res => {
                this.result = true
                this.desc = '您的申请已提交成功，请耐心等待'
              }).catch(err => {
                console.log(err)
              //this.$toast('提交失败')
              })
            });
            lego.send({
              pagetype: 'auth_withcard',
              actiontype: 'fail',
              backup: {
                sourcecode: this.sourcecode,
                version: getCookie('v'),
                app: native.in('zz') ? 'zz' : 'zlj',
                authType: this.authType,
                originsource: this.originsource
              }
            })
          } else {
            this.result = true
            lego.send({
              pagetype: 'auth_withcard',
              actiontype: 'success',
              backup: {
                sourcecode: this.sourcecode,
                version: getCookie('v'),
                app: native.in('zz') ? 'zz' : 'zlj',
                authType: this.authType,
                originsource: this.originsource
              }
            })
          }
          this.submiting = false
        })
        .catch((res) => {
          console.log(res)
          this.submiting = false
        })
    },
    closePage() {
      native.close()
    },
    onInput(value) {
      this.cardId += value;
    },
    onDelete() {
      this.cardId = this.cardId.slice(0, -1);
    }
  },
  watch: {
    name: function(newval, _oldval) {
      this.name = newval.replace(/\./g, '·')
    },
    authType: function(_newval, _oldval) {
      this.picKeyBack = ''
      this.picKeyFro = ''
      this.name = ''
      this.cardId = ''
    }
  }
}
</script>

<style lang="less" scoped>
  @import 'index.less';
</style>
